<template>
  <component
    :is="componentName"
  ></component>
</template>

<script>
import { mapState } from 'vuex'

export default {
  components: {
    Referral: () => import('./Referral.vue'),
    ReferralTeacher: () => import('./ReferralTeacher.vue'),
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    componentName() {
      if (this.currentUser && this.currentUser.isRefererEduPromotionGroup) {
        return 'ReferralTeacher'
      }

      return 'Referral'
    },
  },
  watch: {
    componentName: {
      handler(value) {
        let title = 'Refer a friend'

        if (value === 'ReferralTeacher') {
          title = 'Refer a teacher'
        }

        this.$nextTick(() => {
          document.title = title
        })
      },
      immediate: true,
    },
  },
}
</script>
